import React, { useState } from 'react';
import '../../../entrydoor.css';

const VerticalGrills = ({ value, onChange, id = 'VerticalGrills', label = 'Vertical:', disabled = false }) => {
    const [selectedVerticalGrills, setSelectedVerticalGrills] = useState(value || "0");
     const [VerticalGrillsError, setVerticalGrillsError] = useState("");

    const handleVerticalGrillsChange = (e) => {
        //setSelectedVerticalGrills(e.target.value);
        validateVerticalGrills(e.target.value);
        onChange(e.target.value);
    };
    const validateVerticalGrills = (value) => {
        const numericValue = value.replace(/\D/g, ""); // Allow only numbers
        setSelectedVerticalGrills(numericValue);
      
        if (numericValue && (numericValue < 0 || numericValue > 10)) {
            setVerticalGrillsError('must be between 0" and 10"');
        } else {
            setVerticalGrillsError("");
        }
    };
    return (
        <div className="a-container">
            <label style={{ display1: "none" }} disabled={disabled} htmlFor={id}>{label}</label>
            <input style={{ display1: "none" }}
                disabled={disabled}
                id={id}
                value={selectedVerticalGrills}
                onChange={handleVerticalGrillsChange}
            >
            </input>
            {VerticalGrillsError && <p className="error">{VerticalGrillsError}</p>}
        </div>
    );
};

export default VerticalGrills;
